import type { IconProps } from "./icon-types";

/**
 * 시계(clock). 시각 선택(TimeInput) 등 시간 관련 진입점에서 사용.
 *
 * `react-icons/lu`의 `LuClock`(Lucide `clock`)을 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 다른 c6 stroke 글리프와 톤·크기를 맞추기 위해 24 그리드 / stroke(2) 기반.
 */
export const ClockIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
